/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */
export enum SystemMessageExchange {
  request = "request",
  response = "response",
}
